import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import ahCawTransportUtility from "utilities/login/ah-caw-transport-utility/2.2.3/js/ah-caw-transport-utility";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.6/js/helpers-sparta";
import spartaInputUtility from "utilities/global/sparta-input-utility/12.1.1/js/sparta-input-utility";
import radioButton from "utilities/helpers/helpers-radio-button/4.3.5/js/helpers-radio-button";
import spartaTemplates from "modules/login/ah-caw-dp-module/6.3.0/js/templates";
import "css!modules/login/ah-caw-dp-module/6.3.0/css/ah-caw-dp-module.scss.css";






export default class ahCawDpController {
  constructor(parentModule) {
    this.parentModule = parentModule;
    this._model = parentModule.model;
    this._view = parentModule.view;

    const self = this;
    this.bindThisConext(['_defineVars', '_bindEventHandlers', '_listen',
        '_subscribeEvents', '_initialize'],
      self, '');
  }

  bindThisConext(methods, context, suffix = 'Scoped') {
    const self = context;

    if (methods && $.isArray(methods) && methods.length > 0) {
      $(methods).each((index, method) => {
        if (self[method]) {
          self[method + suffix] = self[method].bind(context);
        } else {
          console.log(`Method: ${method} Not found in current context.`);
        }
      });
    }
  }

  _defineVars() {
    return this;
  }

  _bindEventHandlers() {
    return this;
  }

  _listen() {
    return this;
  }

  _subscribeEvents() {
    const main = this.parentModule;
    const controller = this.parentModule.controller;
    main.Events.sub(cawEventsMasterUtility.EVENTS.SHOW_DEVICE_PREF, (e) => {
      main._debug('Initialize DP widget with: ', e);
      main.callbackTarget = e.data.successCallback;
      main._debug(`DP Module: ${JSON.stringify(e)}`);
      controller.emit({ context: 'PAINT-DP-MODULE'});
      $('#ahPageTitleContainer').addClass('hidden');

    });
    return this;
  }

  _initialize() {
    this._defineVars()
      ._bindEventHandlers()
      ._subscribeEvents()
      ._listen();
  }
}
